import React, { FC } from 'react';

export const Progress: FC<{
  isFloating?: boolean;
  doShow?: boolean;
  backdrop?: boolean;
  className?: string;
}> = ({ isFloating = true, doShow = true, backdrop = false, className = '' }) => {
  if (!doShow) {
    return null;
  }
  const floatingStyle = isFloating ? 'floating' : 'nonFloating';
  const progressOverlay = backdrop ? 'progress-overlay' : '';
  return (
    <div className={`progressWrapper ${floatingStyle} ${progressOverlay}`} data-testid="progress">
      <span aria-hidden="true" className={`spinner-icon ${className}`} />
    </div>
  );
};

Progress.displayName = 'Progress';
export default Progress;
